<template>
  <div class="form-box">
    <div class="buttons-box" v-if="nowTab == 1 || nowTab == 3">
      <div class="title" style="margin-top: -15px">企业登录</div>
      <div style="padding-top: 20px">
        <a class="text" @click="checkTab(1)" :class="{ hover: nowTab == 1 }"
          >密码登录</a
        >
        <a class="text" @click="checkTab(3)" :class="{ hover: nowTab == 3 }"
          >验证码登录</a
        >
      </div>
    </div>
    <login-password
      v-if="nowTab == 1"
      :role="role"
      @close="closeHandler"
    ></login-password>
    <user-reg
      v-if="nowTab == 2"
      :role="role"
      @goBackLogin="goBackLogin"
    ></user-reg>
    <login-msm v-if="nowTab == 3" :role="role"></login-msm>
    <reset-password
      v-if="nowTab == 4"
      :role="role"
      @goBackLogin="goBackLogin"
    ></reset-password>
    <div class="reg-box" v-if="nowTab == 1 || nowTab == 3">
      <a class="txt-btn" @click="registerHandler()">企业注册</a>
      <a
        v-if="nowTab == 1 || nowTab == 3"
        class="txt-btn find-password"
        @click="findPassword()"
        >找回密码</a
      >
    </div>

    <trialDialog
      :dialogVisible="dialogVisible"
      @onCancel="onCancel"
      @singleHandler="singleHandler"
      @companyHandler="companyHandler"
    ></trialDialog>
    <confirmDialog
      :dialogVisible="confirmVisible"
      dialogTitle="提示"
      @onCancel="onConfirmCancel"
    ></confirmDialog>
  </div>
</template>

<script>
import loginPassword from '@/components/account/model/login-password'
import userReg from '@/components/account/model/user-reg'
import loginMsm from '@/components/account/model/login-msm'
import resetPassword from '@/components/account/model/reset-password'
import trialDialog from '@/components/dialog/trial-dialog'
import confirmDialog from '@/components/dialog/confirm-dialog'
export default {
  components: {
    loginPassword,
    userReg,
    loginMsm,
    resetPassword,
    trialDialog,
    confirmDialog,
  },
  props: ['toTab', 'mode'],
  data() {
    return {
      confirmVisible: false,
      dialogVisible: false,
      nowTab: 1,
      role: 2,
    }
  },
  watch: {
    toTab(val) {
      this.nowTab = val
    },
    mode(val) {
      this.role = val
    },
  },
  mounted() {
    this.nowTab = this.toTab
    if (this.role == '') {
      let ktk = this.$cookies.get('kao_token')
      if (ktk != '') {
        location.href = 'https://kao.acmcoder.com/b/'
      }
    }
  },
  methods: {
    closeHandler() {
      this.$emit('close')
    },
    goBackLogin() {
      this.nowTab = 1
    },
    checkTab(tab) {
      this.nowTab = tab
    },
    registerHandler() {
      if (this.$cookies.get('role')) {
        this.nowTab = 2
      } else {
        this.dialogVisible = true
      }

      //this.nowTab = 2;
    },
    findPassword() {
      this.nowTab = 4
    },
    companyHandler() {
      this.nowTab = 2
      this.dialogVisible = false
    },
    onCancel() {
      this.dialogVisible = false
    },
    onConfirmCancel() {
      this.confirmVisible = false
    },
    singleHandler() {
      this.dialogVisible = false
      this.confirmVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.form-box {
  padding: 0px 0px 10px;
  .title {
    text-align: center;
    padding: 10px 0 20px 0;
    font-size: 20px;
    font-weight: 300;
  }
  .buttons-box {
    text-align: center;
    padding: 10px 0px;
    font-size: 16px;
    a {
      cursor: pointer;
      padding: 10px 40px;
      border-radius: 5px;

      &.text {
        color: #666;
        border: 1px solid #fff;
      }
      &.hover {
        color: #29bdb9;
        border: 1px solid #29bdb9;
      }
    }
  }
  .reg-box {
    text-align: center;
    padding: 5px 0px;
    font-size: 16px;
    position: relative;
    .txt-btn {
      cursor: pointer;
    }
    .find-password {
      position: absolute;
      right: 66px;
      margin-right: -22px;
      color: #999;
      font-size: 12px;
      padding-top: 3px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/bussiness.vue